import React from "react";

interface Props {
  children: React.ReactNode;
}

const FormRow = (props: Props) => {
  return (
    <div className="form-row row w-100 mb-4 mx-0 align-items-center">
      {props.children}
    </div>
  )
}

export default FormRow;
